import { EpicH1Span } from "@constellation-academy/epic-ui";
import { useContext } from "react";
import { useLazyLoadQuery } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type offers_Query } from "@relay/offers_Query.graphql";
import { OffersScreenContext } from "./offers.context";
import { QUERY } from "./offers.graphql";
import { OffersContextProvider } from "./offers.provider";
import { HeaderWrapper, Wrapper } from "./offers.styles";
import { CreateCourseLearnableButton } from "./parts/create-course-learnable-button";
import { OffersFilters } from "./parts/offers-filters";
import { OffersTable } from "./parts/offers-table";
import { BaseScreen } from "../../components/base-screen";

export const OffersScreen = () => {
	const { t } = useTranslation("common");
	const {
		filters: { ...filters },
	} = useContext(OffersScreenContext);

	const query = useLazyLoadQuery<offers_Query>(
		QUERY,
		{ ...filters },
		{ fetchPolicy: "network-only" },
	);

	return (
		<BaseScreen>
			<OffersContextProvider>
				<HeaderWrapper>
					<EpicH1Span>{t("offers.screenTitle")}</EpicH1Span>
					<Wrapper>
						<CreateCourseLearnableButton />
						<OffersFilters queryFragmentRef={query} />
					</Wrapper>
				</HeaderWrapper>
				<OffersTable queryFragmentRef={query} />
			</OffersContextProvider>
		</BaseScreen>
	);
};
